export default __webpack_public_path__ + "static/media/TR.6169cafd.jpg";